import ScrollToTopContainer from './ScrollToTopContainer';

export default ScrollToTopContainer;
